/** 停车时长规律 */
import {GetParkingDuration} from '@/services/api'
import { useRequest } from 'ahooks'
import { Spin } from 'antd'
import ReactEcharts from 'echarts-for-react';
import React, { useCallback, useState,useMemo, useEffect } from 'react'
import Panel from '../index'
import styles from './style.module.scss'
import { Pie } from '@ant-design/charts';
import { autorun } from 'mobx'
import ImgSource from '@/assets/img/resource/resource.png'
import Abutton from '@/components/Abutton'

interface ParkingData {
  zoneName: string;
  count: number;
}

interface DurationData {
  [key: string]: ParkingData[];
}

export interface ParkikngResourceProps {
  areaCode?: string
}
/** 统计首页跳转地址 */
const iframeURL ="http://lz.dgjx0769.com/lz/#/UrbanIntegration/BasicDataManage/BasicData";
const ParkikngResource: React.FC<ParkikngResourceProps> = (props) => {
    // const [data, setData] = useState<DurationData>({});
 
  const service = useCallback(() => {
    // return GetDistributeData(  props.areaCode )
    return GetParkingDuration( {areaCode:props.areaCode} )
  },[props.areaCode])

  const { loading, data = {}, error } = useRequest(service, {
    formatResult: res => res.data
  })
 
  if (error && loading === false) {
    <Panel
      title="停车时长规律"
    >
      <div className="fetch_container" style={{ height: 89 }}>
        请求错误
      </div>
    </Panel>
  }
  
  // 处理数据，将对象转换为数组格式
  const showData = useMemo(() => {
    if (!data) return [];
    return Object.entries(data).map(([key, value]) => ({
      name: key,
      value: (value as ParkingData[]).reduce((sum: number, item: ParkingData) => sum + item.count, 0)
    }));
  }, [data]);

/**图标数据 */
const AbuttonBox = useMemo(() => {
  return <Abutton  iframeURL={iframeURL} text={''}/>
}, [])

/**图表配置 */
const Option = useMemo(() => {
  if (!data) return {};

  // 获取所有时段
  const timePeriods = Object.keys(data);
  // 获取所有区域类型
  const zoneTypes = Array.from(new Set(
    Object.values(data).flatMap(items => 
      (items as ParkingData[]).map(item => item.zoneName)
    )
  ));

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    // legend: {
    //   data: zoneTypes,
    //   textStyle: {
    //     color: 'rgba(32, 188, 252, 1)'
    //   }
    // },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '20%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: timePeriods,
      axisLine: {
        lineStyle: {
          color: 'rgba(32, 188, 252, 1)'
        }
      },
      axisLabel: {
        color: 'rgba(32, 188, 252, 1)',
        interval: 0,
        rotate: 45
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: 'rgba(32, 188, 252, 1)'
        }
      },
      axisLabel: {
        color: 'rgba(32, 188, 252, 1)'
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(32, 188, 252, 0.1)'
        }
      }
    },
    series: zoneTypes.map((zoneType, index) => ({
      name: zoneType,
      type: 'bar',
      stack: 'total',
      data: timePeriods.map(period => {
        const periodData = data[period];
        const item = periodData?.find((item: ParkingData) => item.zoneName === zoneType);
        return item?.count || 0;
      }),
      barWidth: '30%',
      itemStyle: {
        color: ['#00ccff', '#6772ff', '#008aff', '#2dbcdf', '#6275d5', '#4aa3e2'][index % 6]
      },
      label: {
        show: true,
        position: 'inside',
        color: '#fff'
      }
    }))
  };
}, [data]);

  return (
    <Panel
      title="停车时长规律"
    >
           
           {
        loading ?
          <div className="fetch_container" style={{ height: 120 }}>
            <Spin/>
          </div> :
          <ReactEcharts
          option={Option}
          style={{height: '280px', width: '100%'}}
          className='react_for_echarts' 
          />

      }
    </Panel>
  )
}

export default ParkikngResource
